import { Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { UiObject } from "@models/configurators/ui-object";
import { IActionBar } from "@models/entity-models";

@Kbo(CToken.ActionBar)
export class ActionBar extends UiObject implements IActionBar {

    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public buttonStyle: string;    
    public iconSize: number;
}
